import axios from 'axios';
import { Room, RoomParams } from '../interfaces/api/room';

export interface RoomSearchFilterParam {
	search?: string;
	floor?: string;
	floor__building?: string;
	floor__building__organization?: string;
}

function queryBuilderSearchFilter(params: RoomSearchFilterParam): URLSearchParams {
	const queryParams = new URLSearchParams();
	if (params.search) {
		queryParams.append('search', params.search);
	}
	if (params.floor) {
		queryParams.append('floor', params.floor);
	}
	if (params.floor__building) {
		queryParams.append('floor__building', params.floor__building);
	}
	if (params.floor__building__organization) {
		queryParams.append('floor__building__organization', params.floor__building__organization);
	}
	return queryParams;
}

export async function getRooms(): Promise<Room[]> {
	try {
		const response = await axios.get<Room[]>('api/rooms/');
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getRoom(id: number): Promise<Room> {
	try {
		const response = await axios.get<Room>(`api/rooms/${id}/`);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getRoomsSearchFilter(params: RoomSearchFilterParam): Promise<Room[]> {
	try {
		const queryParams = queryBuilderSearchFilter(params);
		const response = await axios.get<Room[]>(`api/rooms/`, {
			params: queryParams,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function patchRoom(id: number, params: RoomParams): Promise<Room> {
	try {
		const response = await axios.patch<Room>(`api/rooms/${id}/`, params);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
